import { render } from "./planner.vue?vue&type=template&id=654daada"
import script from "./planner.vue?vue&type=script&lang=js"
export * from "./planner.vue?vue&type=script&lang=js"

import "./planner.vue?vue&type=style&index=0&id=654daada&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__